

















































import { Component, Vue } from "vue-property-decorator";
import SystemConst from "@/config/const";
import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
firebase.auth().languageCode = "ja";
import UserService from "@/services/UserService";

@Component
export default class SettingEmailApp extends Vue {
  settingType = SystemConst.SETTING_TYPE;
  selectedSettingType = "SettingEmail";
  nowEmail = "";
  newEmail = "";
  newEmailConfirm = "";
  password = "";
  message = "";
  showPassword = false;
  user: any;
  isProcessing = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private ruleEmail: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => /.+@.+\..+/.test(v) || "有効なメールアドレスではありません。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rulePassword: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  changePage() {
    const selectedSetting = this.selectedSettingType;
    this.$router.push({ name: selectedSetting });
  }

  async setEmail() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    this.message = "";
    if (this.refs.setEmailForm.validate()) {
      await this.doSetEmail();
    }
    this.isProcessing = false;
  }

  async validEmailAndPassword() {
    let valid = true;
    if (this.nowEmail === this.newEmail) {
      this.message = "現在のメールを入力しないでください";
      return false;
    }

    //checking email
    const user = firebase.auth().currentUser;
    if (!user) return false;
    const credential = firebase.auth.EmailAuthProvider.credential(
      this.nowEmail,
      this.password
    );

    // checking password
    let wrongPass = false;
    await user
      .reauthenticateWithCredential(credential)
      .catch(function (error: any) {
        valid = false;
        if (error.code === "auth/wrong-password") wrongPass = true;
      });
    if (wrongPass) this.message = "パスワードが間違います";
    return valid;
  }

  async rollBackEmail() {
    await UserService.updateUser({ email: this.user.email });
  }

  async doSetEmail() {
    const validEmailAndPassWord = await this.validEmailAndPassword();
    if (!validEmailAndPassWord) return;

    if (this.nowEmail === this.newEmail) {
      this.message = "現在のメールを入力しないでください";
      return;
    }

    const user = firebase.auth().currentUser;
    if (!user) return;
    const messDuplicateEmail =
      "Validation failed: Email has already been taken";

    const rsp = await UserService.updateUser({ email: this.newEmail }).catch(
      (err: any) => {
        if (err.response.data.message === messDuplicateEmail) {
          this.message = "このメールは既に存在します";
        } else {
          this.message = "エラーが発生しました。更新できません";
        }
        return { data: { user: null } };
      }
    );
    if (rsp && rsp.data.user) {
      await user
        .updateEmail(this.newEmail)
        .then(async () => {
          const domain = window.location.host;
          const protocol = window.location.protocol;
          const redirectURL =
            protocol + "//" + domain + "/password/set-email/done";
          user
            .sendEmailVerification({ url: redirectURL, handleCodeInApp: false })
            .then(() => {
              // メール認証待ち画面に遷移する
              this.$router.push({ name: "SignupNotValid" });
            })
            .catch(() => {
              this.message = "確認メールの送信に失敗しました。";
            });
        })
        .catch(async (err: any) => {
          if (err.code === "auth/email-already-in-use") {
            this.message = "このメールは既に存在します";
          }
          await this.rollBackEmail();
        });
    }
  }

  public created() {
    this.user = this.$store.getters.user;
    // プロフィール未入力だったらプロフィール画面に強制遷移する
    const user = firebase.auth().currentUser;
    if (user != null && user.email != null) {
      this.nowEmail = user.email;
      // ドキュメントなかったら遷移する
    }
  }

  public mounted() {
    document.title =
      "メールアドレスを変更する | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "メールアドレスを変更する | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }
}
